import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Modal from 'components/Modal/Modal'
import Checkbox from 'components/Form/Checkbox/Checkbox'

import storage from 'common/utils/storage'

import { PRODUCT_LIST_FREE } from 'common/constants/ProductConstants'

import image from './i/image.png'

import styles from './HowEducationFreeWorksModal.module.scss'

export const STORAGE_KEY = 'DONT_SHOW_EDUCATION_EXTERNAL_LINKS'

const HowEducationFreeWorksModal = () => {
    const { t } = useTranslation()
    const { organizations, projectSubscription } = useSelector(state => state)

    const [isVisible, setIsVisible] = useState(false)
    const [isDontShowAgainMark, setIsDontShowAgainMark] = useState(false)

    useEffect(() => {
        if (projectSubscription && !projectSubscription.expired) return
        const productCode = organizations.selectedSubscription.product.productCode
        const isEducationFree = productCode === PRODUCT_LIST_FREE.EducationFree
        if (!isEducationFree) return
        if (storage.getValue(STORAGE_KEY)) return
        setIsVisible(true)
    }, [])

    const onClose = () => {
        if (isDontShowAgainMark) storage.setValue(STORAGE_KEY, 'true')
        setIsVisible(false)
    }

    if (!isVisible) return null

    return (
        <Modal closeOnOverlayClick={false} closeOnEsc={false}>
            <div className={styles.howEducationFreeWorksModal}>
                <img className={styles.image} src={image} alt="image" />
                <div className={styles.content}>
                    <h4 className={styles.title}>{t('Before we continue...')}</h4>
                    <h5 className={styles.subTitle}>{t('Some features are limited on the free plan')}</h5>
                    <p className={styles.text}>
                        {t(
                            'You’re using the free plan, which lets you create and publish quizzes, games, and worksheets.\nHowever, the ability to add external links to your projects is only available with a paid subscription.',
                        )}
                    </p>
                    <button className="button" data-size="lg" data-variant="primary" onClick={onClose}>
                        {t("Ok, let's continue!")}
                    </button>
                    <Checkbox
                        className={styles.checkbox}
                        label={t("Don't show again")}
                        value={isDontShowAgainMark}
                        onUpdate={value => setIsDontShowAgainMark(value)}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default HowEducationFreeWorksModal
